/**
 * Offerlist component.
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-widget/widget',
    'library/fcse-compatibility/object'
    ], function ($, _, Widget, Object) {

        var Checkbox = function(element) {
            Widget.apply(this, arguments);

            // Store element
            this.element = $(element);

            this._init();
        };

        Checkbox.prototype = $.extend(Object.create(Widget.prototype), {

            /**
             * Initialize Checkbox
             *
             * @private
             */
            _init: function() {
                var self = this;
                $(this.element).on('change', function() {
                    self.setValue(this.checked?0:10000);
                });
            },
            setValueToUi: function() {
            }
        });

        return Checkbox;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/checkbox/checkbox.js